import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

import { PlayerListenerComponentDirective } from '../../../base-component/player-listener.component'
import { PlayerLogic } from '../../../player/AngPlayer'
import { CartService } from '../../../services/cart.service'

@Component({
  selector: 'bmcore-player-controls',
  templateUrl: './bmcore-player-controls.component.html',
  styleUrls: ['./bmcore-player-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcorePlayerControlsComponent extends PlayerListenerComponentDirective<any> implements OnInit {
  @Input() showShuffleBtn = false
  @Input() showRepeatBtn = false
  @Input() showMobLgView = false
  @Input() showMobSmView = false

  constructor(
    public player: PlayerLogic,
    protected cartService: CartService
  ) {
    super(player, cartService)
  }

  ngOnInit() {
    super.ngOnInit()
  }
}
